import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Edycja dostępnych baterii i testów',
  name: 'Nazwa baterii / testu',
  cancel: 'Anuluj',
  save: 'Zapisz',
  add: 'Dodaj baterię',
});
